export default __webpack_public_path__ + "static/media/bookcover - back.95982088.png";